import { useMemo } from 'react';
import { useGetCurrentUserQuery } from '@teachur/http-client';
import { useScheduledCalls } from './useScheduledCalls';
import { StudentDashboardData } from '../types';

export const useStudentDashboard = () => {
  const {
    data: currentUser,
    isLoading: isUserLoading,
    isError: isUserError,
  } = useGetCurrentUserQuery();
  const { data: scheduledCallsData, isLoading: isCallsLoading } = useScheduledCalls({
    page: 1,
    pageSize: 100,
  });

  const dashboardData = useMemo<StudentDashboardData | undefined>(() => {
    if (!currentUser) return undefined;

    return {
      scheduledCalls: scheduledCallsData?.data || [],
      recentActivity: [],
    };
  }, [currentUser, scheduledCallsData]);

  return {
    data: dashboardData,
    isLoading: isUserLoading || isCallsLoading,
    isError: isUserError,
  };
};
